export default "__VITE_ASSET__D7$GGdy0__";